var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttribution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8,44c-2.6,0-5.2-0.5-7.6-1.6c-2.3-1-4.4-2.5-6.2-4.2c-1.8-1.8-3.2-4-4.2-6.3c-1-2.4-1.5-5-1.5-7.7c0-2.7,0.5-5.4,1.6-7.8c1-2.4,2.4-4.6,4.2-6.4c1.8-1.8,3.9-3.3,6.2-4.3c4.9-2.1,10.4-2.1,15.3,0c2.3,1,4.5,2.5,6.2,4.3c1.8,1.9,3.2,4,4.2,6.4c1,2.5,1.6,5.1,1.6,7.8v15.7c0,1.1-0.4,2.1-1.2,2.9c-0.7,0.8-1.8,1.2-2.8,1.2H23.8z M23.8,40.8c4.4,0.1,8.7-1.7,11.8-4.8c3.2-3.1,5-7.3,4.9-11.7c0.1-4.5-1.6-8.9-4.8-12.2c-3-3.3-7.3-5.1-11.7-5c-4.5-0.1-8.8,1.7-11.9,5C9,15.3,7.2,19.7,7.3,24.2c0,1,0.1,1.9,0.2,2.9c0.2,0.9,0.4,1.9,0.7,2.7l8-8.1l6.5,5.6l7.5-7.8h-3.8v-3h8.9v9h-3v-3.9l-9.5,9.6l-6.5-5.6l-6.8,6.9c1.4,2.5,3.5,4.5,5.9,5.9C18,40,20.9,40.8,23.8,40.8L23.8,40.8z M39.7,41.4c0.4,0,0.8-0.2,1-0.5c0.3-0.3,0.4-0.7,0.4-1.1c0-0.4-0.2-0.8-0.4-1c-0.6-0.5-1.5-0.5-2.1,0.1c-0.5,0.6-0.5,1.5,0.1,2.1C38.9,41.2,39.3,41.4,39.7,41.4L39.7,41.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttribution);
export default __webpack_public_path__ + "static/media/attribution.f799dea31ac0d07f6ec905a0268de628.svg";
export { ForwardRef as ReactComponent };